// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__bjEtu","dragIcon":"SortableItem_dragIcon__3KKV1","disabled":"SortableItem_disabled__2JSTI"};